
import { Parameter } from "@/types/parameter.type";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    headerFile: { type: Object as () => string[], required: false },
    checkParameter: { type: Object as () => string[], required: false },
    checkUpload: { type: Object as () => boolean[], required: false },
    headerParameter: { type: Object as () => Parameter[], required: false },
    notHeader: { type: Object as () => string[], required: false },
    startDate: Date,
    endDate: Date,
  },
  data() {
    return {
      // headerParameter: [] as string[],
      headerUpload: [] as boolean[],
      parameters: [] as Parameter[],
      alert: false,
    };
  },

  methods: {
    clickCheck(index: number) {
      if (this.headerUpload && this.headerParameter) {
        if (this.headerUpload[index] === true && this.headerParameter[index].code?.length === 0) {
          this.headerUpload[index] = false;
          this.alert = true;
          // ElMessage.warning(this.$t("warning.notSelectedParameter"));
        } else {
          this.alert = false;
        }
      }
    },
    addParameter(index: number) {
      if (this.headerUpload && this.headerParameter) {
        if (
          this.headerUpload[index] === true &&
          this.headerParameter[index].code?.includes("field")
        ) {
          this.headerUpload[index] = false;
        } else {
          this.headerUpload[index] = true;
        }
        this.alert = false;
      }
    },
    formatDate(date: Date | undefined) {
      if (date instanceof Date) {
        const options: Intl.DateTimeFormatOptions = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        };
        return date.toLocaleString(undefined, options);
      }
      return "";
    },
    doSave() {
      return { headerParameter: this.headerParameter, headerUpload: this.headerUpload };
    },
  },
});
